// extracted by mini-css-extract-plugin
export var emojiPickerContainer = "index-module--emojiPickerContainer--wkT+9";
export var emojiSelectorContainer = "index-module--emojiSelectorContainer--zMtY6";
export var emojiSelectorIsOpen = "index-module--emojiSelectorIsOpen--iqoyc";
export var handWaveAnimation = "index-module--handWaveAnimation--pTlN6";
export var header = "index-module--header--WlPCT";
export var hello = "index-module--hello--BeUhh";
export var helloLanguage = "index-module--helloLanguage--qWkLR";
export var title = "index-module--title--mjrVm";
export var waveEmoji = "index-module--waveEmoji--Kqa-n";